// extracted by css-extract-rspack-plugin
export default {"cls1":"FocusedNavView-cls1_aXt","cls2":"FocusedNavView-cls2_62c FocusedNavView-cls1_aXt"};